module.exports = __webpack_public_path__ + "static/img/df_img.227ae60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/df_img.png
// module id = VUPR
// module chunks = 1